import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4756a092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "test-time" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/timer.svg",
  alt: "",
  width: "20",
  height: "20"
}, null, -1))
const _hoisted_3 = { class: "test-time__bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("残"),
  /*#__PURE__*/_createElementVNode("rp", null, "（"),
  /*#__PURE__*/_createElementVNode("rt", null, "のこ"),
  /*#__PURE__*/_createElementVNode("rp", null, "）")
], -1))

import { computed, inject, ref } from "vue"
import {examKey, timerKey} from "@/main";
import { QuestionData } from "@/store/exam";

interface Props {
  initTimeRemaining: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Timer',
  props: {
    initTimeRemaining: null
  },
  emits: ['timeover', 'update'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  initTimeRemaining: number;
};

const timeWarning = 180;

const exam = inject(examKey);
const timer = inject(timerKey);





const timeLimit = ref(2700);
const timeRemaining = ref(2700);

const progress = computed(() => timeRemaining.value / ( timeLimit.value / 100));

const init = async() => {
  const questions: QuestionData | undefined = await exam?.questions();
  if (!questions) return;

  const readingTimeLimit = questions.reading.timeLimit || 1;
  timeLimit.value = readingTimeLimit;
  timeRemaining.value = readingTimeLimit < props.initTimeRemaining ? readingTimeLimit : props.initTimeRemaining;

  // sessionから復元
  timer?.init(timeRemaining.value,
      async (_timeRemaining: number) => {
        timeRemaining.value = _timeRemaining;
        emits('update', _timeRemaining);
      },
      () => {
        emits('timeover');
      }
    );

  timer?.start();
}
init();

const timeRemainingStr = computed(() =>
  timeRemaining.value >= 60 ? Math.ceil(timeRemaining.value / 60) + '分' : Math.ceil(timeRemaining.value) + '秒'
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        style: _normalizeStyle({'width' : `${_unref(progress)}%`}),
        class: _normalizeClass({'warn': (timeRemaining.value < timeWarning)})
      }, null, 6)
    ]),
    _createElementVNode("p", {
      class: _normalizeClass({'warn': (timeRemaining.value < timeWarning)})
    }, [
      _hoisted_4,
      _createTextVNode("り："),
      _createElementVNode("span", null, _toDisplayString(_unref(timeRemainingStr)), 1)
    ], 2)
  ]))
}
}

})